import React, { useState } from "react";
import axios from "axios";
import "../styles/main.css";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    if (username !== "admin") {
      setError("نام کاربری یا کلمه ی عبور اشتباه است");
      return;
    }

    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    try {
      const response = await axios.post(
        "https://enduserapi.armanitala.com/api/v1/Users/Token",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      localStorage.setItem("token", response.data.access_token);
      navigate("/dashboard");
    } catch {
      setError("نام کاربری یا کلمه ی عبور اشتباه است");
    }
  };

  return (
    <div className="login-container">
      <form className="card" onSubmit={handleLogin}>
        <h2>ورود به پنل مدیریت</h2>
        <input
          type="text"
          placeholder="نام کاربری"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="کلمه عبور"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="error">{error}</p>}
        <button type="submit">ورود</button>
      </form>
    </div>
  );
}

export default Login;
